import * as config from "../config";
import { connect } from "react-redux";
import * as accountActions from "../actions/accountActions";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

class Header extends PureComponent {
  static propTypes = {
    showHeader: PropTypes.bool,
    title: PropTypes.string.isRequired,
    me: PropTypes.object,
    history: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
  };

  _logout = () => {
    this.props.logout().then(() => {
      window.location.assign(config.logoutUrl);
    });
  };

  render() {
    let { me } = this.props;
    return (
      <header className="header">
        <div className="content">
          <div className="row">
            <div className="col">
              <img
                alt="AANP"
                className="logo"
                src={`${config.rootUrl}/images/logo.gif`}
              />
            </div>
          </div>
          <div className="row d-none d-lg-flex">
            <div className="col">
              <h2>{this.props.title}</h2>
            </div>
          </div>
          {me && (
            <div className="row mt-3 mt-lg-0">
              <div className="msg-welcome col-8">
                <div>
                  Welcome, {me.person.firstName} {me.person.lastName}
                </div>
                {me.isImpersonating && (
                  <div className="impersonating">
                    Impersonated by {me.staff.firstName} {me.staff.lastName}
                  </div>
                )}
              </div>
              <div className="col-4 text-right pull-right">
                <button
                  className="link-button link-logout"
                  onClick={(e) => this._logout()}
                >
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
        {this.props.showHeader && (
          <div className="row">
            <div className="col">
              <div className="conference-header box">
                <div className="title">{me.event.eventTitle}</div>
                <img
                  src={me.event.bannerLocation}
                  alt="banner"
                  className="conference-logo"
                />
              </div>
            </div>
          </div>
        )}
      </header>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    me: state.account.me,
  };
};

export default withRouter(connect(mapStateToProps, accountActions)(Header));
